import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './NosAvocats.css';

const NosAvocats = () => {
  const sectionTwoRef = useRef(null);
  const sectionThreeRef = useRef(null);
  const sectionFourRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px'
    };

    const observerCallback = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.classList.contains('animated')) {
          entry.target.classList.add('animated');
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    if (sectionTwoRef.current) observer.observe(sectionTwoRef.current);
    if (sectionThreeRef.current) observer.observe(sectionThreeRef.current);
    if (sectionFourRef.current) observer.observe(sectionFourRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div className="nos-avocats">
      {/* Hero Section */}
      <section className="avocats-hero">
        <div className="avocats-hero-content">
          <h1 className="title">Une Vision Partagée du Droit, Portée par Deux Générations</h1>
          <p className="text">
            Le Cabinet est composé d'une équipe dont les parcours associent expertise académique, expérience devant les différentes juridictions et réflexion stratégique.
            <br /><br />
            Le cabinet réunit des professionnels du droit partageant une même exigence d'excellence et une approche collaborative de la pratique juridique.
          </p>
          <Link to="/contact" className="btn-primary">Consultation</Link>
          <img
            src="https://cabinet-ben-nasr.s3.eu-central-1.amazonaws.com/image+5+(1).png"
            alt="Avocats"
            className="avocats-hero-mobile-image"
          />
        </div>
      </section>

      {/* Second Section - Dr. Taoufik Ben Nasr */}
      <section className="avocat-section" ref={sectionTwoRef}>
        <div className="section-content">
          <div className="text-container">
            <h2 className="title avocat-name">Dr. Taoufik Ben Nasr</h2>
            <div className="avocat-title">
              Fondateur | Avocat à la Cour de Cassation | Professeur émérite | Docteur en droit
            </div>
            <p className="text">
              Maître Taoufik Ben Nasr est le fondateur du cabinet Ben Nasr et une personnalité reconnue dans la communauté juridique tunisienne.
              <br /><br />
              Titulaire d'un doctorat en droit, il est également agrégé des facultés de droit et contribue activement à la formation des juristes et au développement de la réflexion juridique.
              <br /><br />
              Sa carrière se distingue par la combinaison d'une activité académique soutenue et d'une longue pratique contentieuse.
              <br /><br />
              En tant qu'avocat à la Cour de Cassation, il a représenté ses clients dans des affaires juridiques complexes nécessitant une analyse juridique approfondie et une stratégie contentieuse structurée.
            </p>
          </div>
          <div className="image-container">
            <img
              src="https://cabinet-ben-nasr.s3.eu-central-1.amazonaws.com/Taoufik.jpg"
              alt="Maître Taoufik Ben Nasr"
            />
          </div>
        </div>
      </section>

      {/* Third Section - Mehdi Ben Nasr */}
      <section className="avocat-section dark-section" ref={sectionThreeRef}>
        <div className="section-content reverse">
          <div className="text-container">
            <h2 className="title avocat-name">Mehdi Ben Nasr</h2>
            <div className="avocat-title">
              Avocat à la Cour de Cassation
            </div>
            <p className="text">
              Inscrit au barreau depuis 2007, Maître Mehdi Ben Nasr est avocat à la Cour de Cassation.
              <br /><br />
              Son activité se caractérise par une approche fondée sur la stratégie juridique, l'analyse structurée des dossiers et la représentation efficace devant les différentes juridictions.
              <br /><br />
              Il accompagne les clients dans la gestion d'affaires juridiques complexes en élaborant des stratégies juridiques adaptées aux spécificités de chaque dossier.
              <br /><br />
              Son approche associe rigueur analytique et vision stratégique, contribuant à la capacité du cabinet à accompagner efficacement ses clients selon les enjeux juridiques et financiers spécifiques à chaque dossier.
            </p>
          </div>
          <div className="image-container">
            <img
              src="https://cabinet-ben-nasr.s3.eu-central-1.amazonaws.com/Mahdi.jpg"
              alt="Maître Mehdi Ben Nasr"
            />
          </div>
        </div>
      </section>

      {/* Fourth Section - Amine Ben Nasr */}
      <section className="avocat-section" ref={sectionFourRef}>
        <div className="section-content">
          <div className="text-container">
            <h2 className="title avocat-name">Amine Ben Nasr</h2>
            <div className="avocat-title">Avocat</div>
            <p className="text">
              Maître Amine Ben Nasr participe activement aux activités juridiques du cabinet et intervient dans le suivi de nombreux dossiers.
              <br /><br />
              Travaillant en étroite collaboration avec les membres du cabinet, il contribue à l'analyse juridique et à la gestion des dossiers dans le cadre de l'approche collaborative du cabinet.
            </p>
          </div>
          <div className="image-container">
            <img
              src="https://cabinet-ben-nasr.s3.eu-central-1.amazonaws.com/Amine.png"
              alt="Maître Amine Ben Nasr"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default NosAvocats;
